@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/variables-dark";

.linkBgAction:hover {
  background-color: var(--#{$prefix}tertiary-bg) !important;
}
